import { AsyncPipe } from '@angular/common'
import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { RouterModule } from '@angular/router'
import { HlmToaster } from '@spartan-ng/helm/sonner'
import { LayoutAdminDefaultComponent } from './layouts/layout-admin-default/layout-admin-default.component'
import { LayoutClientDashboardComponent } from './layouts/layout-client-dashboard/layout-client-dashboard.component'
import { LayoutClientComponent } from './layouts/layout-client/layout-client.component'
import { LayoutVendorComponent } from './layouts/layout-vendor/layout-vendor.component'
import { PageLayout } from './layouts/page-layout.enum'
import { PageLayoutService } from './layouts/page-layout.service'

@Component({
    imports: [
        RouterModule,
        AsyncPipe,
        LayoutAdminDefaultComponent,
        LayoutClientComponent,
        LayoutClientDashboardComponent,
        LayoutVendorComponent,
        HlmToaster,
    ],
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.css',
})
export class AppComponent {
    readonly PageLayout = PageLayout
    layoutService = inject(PageLayoutService)
}
